import axios from "axios";
import { BASE_API } from "../../constants/api";
import { AUTH_ERROR_CODES } from "../auth/auth-errors";
import { validAccess, refreshAccess, redirectToLogin } from "../auth/token-session";

const axiosHttp = axios.create({ baseURL: BASE_API });
const installedInterceptors = new WeakMap();

// Authentication endpoints manage credentials themselves. Never refresh recursively.
const authenticationPaths = new Set([
    "login/", "logout/", "token/", "token/refresh/",
    "otp/", "otp/expiration/", "auth/challenge/",
]);

function backendPath(config) {
    try {
        const backend = new URL(BASE_API, window.location.origin);
        const request = new URL(config.url || "", config.baseURL || window.location.origin);
        const prefix = backend.pathname.endsWith("/") ? backend.pathname : `${backend.pathname}/`;

        if (request.origin !== backend.origin || !request.pathname.startsWith(prefix)) {
            return null;
        }
        return request.pathname.slice(prefix.length);
    } catch (_) {
        return null;
    }
}

function isAuthenticationRequest(config) {
    return authenticationPaths.has(backendPath(config));
}

function canRefreshRequest(config) {
    return backendPath(config) !== null && !isAuthenticationRequest(config);
}

export async function prepareAuthenticatedRequest(config) {
    if (canRefreshRequest(config) && localStorage.getItem("token")) {
        const accessToken = await validAccess();
        config.headers = { ...config.headers, Authorization: `Bearer ${accessToken}` };
    }
    return config;
}

export async function handleAuthenticationError(client, error) {
    const request = error.config;
    if (!request || backendPath(request) === null) {
        throw error;
    }

    const errorCode = error.response?.data?.code;
    const canRetry = canRefreshRequest(request) && !request._refreshRetried;

    if (errorCode === AUTH_ERROR_CODES.ACCESS_TOKEN_EXPIRED && canRetry) {
        request._refreshRetried = true;
        const accessToken = await refreshAccess();
        request.headers = { ...request.headers, Authorization: `Bearer ${accessToken}` };
        return client(request);
    }

    if (errorCode === AUTH_ERROR_CODES.SESSION_REVOKED) {
        redirectToLogin();
    }
    throw error;
}

export function installRefreshInterceptors(client) {
    // Reinstallation replaces previous handlers instead of stacking duplicates.
    installedInterceptors.get(client)?.();

    const requestId = client.interceptors.request.use(prepareAuthenticatedRequest);
    const responseId = client.interceptors.response.use(
        response => response,
        error => handleAuthenticationError(client, error),
    );

    const removeInterceptors = () => {
        if (installedInterceptors.get(client) !== removeInterceptors) return;
        client.interceptors.request.eject(requestId);
        client.interceptors.response.eject(responseId);
        installedInterceptors.delete(client);
    };
    installedInterceptors.set(client, removeInterceptors);
    return removeInterceptors;
}

installRefreshInterceptors(axiosHttp);
installRefreshInterceptors(axios);
export default axiosHttp;

// Previous implementation retained for reference.
// import axios from "axios";
// import { BASE_API } from "../../constants/api";
// import { validAccess, refreshAccess, clearCredentials } from "../auth/token-session";
// const axiosHttp = axios.create({ baseURL: BASE_API });
// const excluded = config => /(?:login|logout|token|otp|auth\/challenge)\//.test(config.url || '');
// const isBackendRequest = config => {
//     try {
//         const base = new URL(BASE_API, window.location.origin);
//         const target = new URL(config.url || '', config.baseURL || window.location.origin);
//         const prefix = base.pathname.endsWith('/') ? base.pathname : base.pathname + '/';
//         return target.origin === base.origin && target.pathname.startsWith(prefix);
//     } catch (_) { return false; }
// };
//
// function installRefreshInterceptors(client) {
//     client.interceptors.request.use(async config => {
//         if (!excluded(config) && localStorage.getItem('token') &&
//             isBackendRequest(config)) {
//             const token = await validAccess();
//             config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
//         }
//         return config;
//     });
//     client.interceptors.response.use(response => response, async error => {
//         const config = error.config;
//         if (!config || !isBackendRequest(config)) return Promise.reject(error);
//         const code = error.response?.data?.code;
//         if (config && !excluded(config) && !config._refreshRetried && code === 'access_token_expired') {
//             config._refreshRetried = true;
//             const access = await refreshAccess();
//             config.headers = { ...config.headers, Authorization: `Bearer ${access}` };
//             return client(config);
//         }
//         if (code === 'session_revoked') { clearCredentials(); window.location.href = '/login'; }
//         return Promise.reject(error);
//     });
// }
// installRefreshInterceptors(axiosHttp);
// installRefreshInterceptors(axios);
// export default axiosHttp;
//
// // Previous interceptor implementation retained for reference.
// // import axios from "axios";
// // import { BASE_API } from "../../constants/api";
// //
// //
// // const axiosHttp = axios.create({
// //   baseURL: `${BASE_API}`,
// // });
// //
// //
// // axiosHttp.interceptors.request.use(
// //   (config) => {
// //     const token = localStorage.getItem('token');
// //     if(token){
// //       return {
// //         ...config,
// //         headers: {
// //           ...(token !== null && { Authorization: `Bearer ${token}`}),
// //           ...config.headers,
// //         },
// //       };
// //     }
// //   },
// //   (error) => {
// //     return Promise.reject(error);
// //   }
// // );
// //
// // axiosHttp.interceptors.response.use(
// //   (response) => {
// //     return response;
// //   },
// //   (error) => {
// //     if (error?.response?.status === 401) {
// //       localStorage.removeItem("profilePopupDismissed");
// //       localStorage.removeItem('user');
// //       localStorage.removeItem('token');
// //       window.location.href = "/login";
// //     }
// //     return Promise.reject(error);
// //   }
// // );
// //
// // export default axiosHttp;
